export function acAction() {
  if (document.querySelector('.js-ac')) {
    const dtEle = document.querySelectorAll('.js-ac dt');
    dtEle.forEach((dt) => {
      dt.addEventListener('click', () => {
        dt.classList.toggle('is-open');
        dt.nextElementSibling.nextElementSibling.classList.toggle('is-open');
      });
    });
  }
}
